    <p class="px-4 pt-4 pb-1">
        <span data-dismiss="modal" aria-label="Close" class="cursor-pointer float-right">
            <span>
                <!-- back svg-->
                <img (click)="goBack(1)" src="assets/themes/icons/cancel.svg" alt="cancel" *ngIf="dss?.selected_suggAssList?.length>0"  />
                <!-- close svg -->
                <img (click)="goBack(0)" src="assets/themes/icons/cancel.svg" alt="cancel"/>
            </span>
        </span>
        <span class="heading-4"><span class="color-black-700">{{mls.languageText.association_verification_screen.key1}}</span><span
                *ngIf="mls?.is_lskey_display==1">(association_verification_screen.key1)</span></span>
    </p>
    <label class="pl-4 pr-4 pb-2 color-error" *ngIf="err_msg!=''">{{err_msg}}</label>
    <div class="position-relative ps calc-13rem" 
        [perfectScrollbar]="config">
        <div class="px-4 bottom-border" *ngFor="let listData of data?.user_doc_list; let idx=index">
            <app-ass-doc-req-card (mrnFocus)="mrnFocus()" (fileUpload)="fileUpload()" [callingfrom]="callingfrom" [listData]="listData" (userInput)="userInput($event)"
                [errObj]="errObj[idx]" [hasChanged]="hasChanged"></app-ass-doc-req-card>
        </div>
    </div>
    <div class="pl-4 pr-4 pb-4">
        <button 
            class="btn-design large filled w-100 " type="button" (click)="submitDoc()">
            <span *ngIf="api_in_process==true" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true"></span>
            {{mls.languageText.association_verification_screen.key3}}<span
                *ngIf="mls?.is_lskey_display==1">(association_verification_screen.key3)</span>
        </button>
    </div>